import script from "./VipHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./VipHistory.vue?vue&type=script&lang=ts&setup=true"

import "./VipHistory.vue?vue&type=style&index=0&id=2c27699f&lang=scss"

const __exports__ = script;

export default __exports__